module.exports = __webpack_public_path__ + "img/vw_skeeball_bright-overlay.83a617b0.jpg";